import NotFound from "@/components/NotFound";
import TokenList from "@/components/TokenList";
const routes = [
  {
    path: "/",
    name: "home",
    redirect: "/tokens",
    component: TokenList,
  },
  { path: "/tokens", component: TokenList },
  /*{ path: "/about", component: About },*/
  { path: "*", component: NotFound },
];

export default routes;
